<template>
  <div class="h-100">
    <main role="main">
      <common-master-table
        primary-key="devSettingSerialId"
        tableNo="mstDevSetting"
        table-api="dev-setting"
        ref="commonMasterTable"
        :editable="editableMixin.devSetting"
        :displayDialogViewDetail="true"
        :hideDeleteToAction="true"
        :hideChbxColumn="true"
        :hideChbxAllColumn="true"
        :hideFirstColHeader="true"
        :hideButtonImportCsv="true"
        :hideButtonAdd="true"
        :hideEditButton="true"
        :hideDeleteButton="true"
        :hideButtonDeleteAll="true"
        :hideOrderButton="true"
        :handleShowCheckBox="true"
        :hideButtonTableHeader="true"
        :hideLableHeader="true"
        :hideIconDrag= "true"
        :disableChangeColumnName="true"
        :hideSortOrder="true"
        :fieldsWithTooltip="fieldsWithTooltip"
        :showDevSettingActionButton="true"
        :showLockMasterButton="false"
        socket-entity="DEV_SETTING_SOCKET"
        class="devSettingTable"
      />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from './custom-components/CommonMasterTable'
import RouterUtils from '../_helpers/router.util'
import AppConstants from '../constants/app.constants'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      updateQueryStr: '',
      fieldsWithTooltip: [AppConstants.DESCRIPTION_KEY]
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  }
}
</script>
<style lang="scss" scoped>
main {
  height: 100%;
}

.devSettingTable >>> .table_wrapper {
  max-height: 100% !important;
  min-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DevSetting.vue